import {
  ScreenerSettingName,
  useSingleFacilityScreenerSettingsQuery
} from '@/hooks/screener-settings';
import { useSelectedSpecificFacilityId } from '@/hooks/useFacilitiesQuery';
import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

export function useIsReferralOutboundEnabled(
  overrideFacilityId?: string
): boolean | undefined {
  const selectedFacilityId = useSelectedSpecificFacilityId();
  const facilityId = overrideFacilityId ?? selectedFacilityId;

  const { data: settingsEntry, isError } =
    useSingleFacilityScreenerSettingsQuery(facilityId ?? '');

  if (!FeatureFlagService.isEnabled(ExacareFeature.CRM_REFERRAL_OUTBOUND)) {
    return false;
  }

  if (!facilityId) {
    return false;
  }

  if (settingsEntry === undefined) {
    return isError ? false : undefined;
  }

  return (
    settingsEntry?.settings?.[ScreenerSettingName.ReferralOutbound] ===
    'enabled'
  );
}
